import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { Link } from "react-router-dom";
import GlobalHelper from "../common/GlobalHelper.jsx";
import ActionButton from "../common/button/actionbutton.component.jsx";
import ConfirmButton from "../common/button/confirmbutton.component.jsx";
import SendEmailModal from "../common/email/sendemail.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import InlineEditUser from "../common/inline-edit/user.component.jsx";
import SideBar from "../common/layout/sidebar.component.jsx";
import StandardList from "../common/listing/list.component.jsx";
import NoResult from "../common/listing/noresult.component.jsx";
import Pagination from "../common/listing/pagination.component.jsx";
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component';
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import InvoicePaymentTerm from '../invoice/paymentterm.component.jsx';
import PricingTableModal from "../quote/analytics/pricingtablemodal.component.jsx";
import InvoiceDueDate from "./duedate.component.jsx";
import ReceivePaymentModal from "./receivepaymentmodal.component.jsx";
import RecurringInvoiceInterval from "./recurring/interval.component.jsx";
import RecurringInvoiceOptions from "./recurring/options.component.jsx";
import RecurringInvoiceSchedule from "./recurring/schedule.component.jsx";
import InvoiceStatusBadge from "./status.component.jsx";

class InvoiceRecurring extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            invoice: this.props.invoice || null,
            project: this.props.project || null,
            proposal: this.props.proposal || null,
            quoteReference: this.props.quoteReference || null,
            emails: this.props.emails || [],
            onRefresh: this.props.onRefresh || function () { },
            onEdit: this.props.onEdit || function () { },
            customFieldDefinitions: [],
            redirect: '',
            modal: '',
            paymentModal: '',
            moreLoading: false,
            loading: false,
            isEditable: this.props.invoice && this.props.invoice.attributes.deletedAt === '',
            pageSize: 10,
            activePage: 1,
            headers: [],
            rows: [],
            totalItemsCount: 0,
            accountLimit: null,
            firstRecurringInvoice: this.props.firstRecurringInvoice || null,
            showFirstRecurringInvoice: true,
            emailSubject: '',
            emailContent: '',
            emailFromName: '',
            toEmail: '',
            ccEmail: '',
            buttonLabel: '',
        }
        this.handleRefreshInvoice = this.handleRefreshInvoice.bind(this)
        this.archive = this.archive.bind(this)
        this.handleClosePreviewModal = this.handleClosePreviewModal.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.handleOnEdit = this.handleOnEdit.bind(this)
        this.configureRecurringEmail = this.configureRecurringEmail.bind(this)
        this.saveRecurringEmail = this.saveRecurringEmail.bind(this)
        this.activate = this.activate.bind(this)
        this.deactivate = this.deactivate.bind(this)
        this.openPricingTableModal = this.openPricingTableModal.bind(this)
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handlePaymentCloseAndRefresh = this.handlePaymentCloseAndRefresh.bind(this)
        this.forceCreateNextInvoice = this.forceCreateNextInvoice.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            invoice: nextProps.invoice || null,
            project: nextProps.project || null,
            proposal: nextProps.proposal || null,
            quoteReference: nextProps.quoteReference || null,
            emails: nextProps.emails || [],
            isEditable: nextProps.invoice && nextProps.invoice.attributes.deletedAt === '',
        })

        if (this.state.showFirstRecurringInvoice && nextProps.firstRecurringInvoice) {
            const firstRecurringInvoice = nextProps.firstRecurringInvoice
            this.setState({
                headers: this.headers(),
                rows: [this.row(firstRecurringInvoice)],
                firstRecurringInvoice: firstRecurringInvoice,
            })
        }
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })
        SideBar.activateMenu('subscription')
        this.refreshInvoices()
    }

    handleRefreshInvoice() {
        this.state.onRefresh(this.state.invoice.id)
        this.refreshInvoices()
    }

    handleOnEdit(e) {
        e.preventDefault()
        this.state.onEdit(this.state.invoice.id)
    }

    loadAnotherInvoice(invoiceId) {
        return function (e) {
            e.preventDefault()
            this.state.onRefresh(invoiceId)
        }.bind(this)
    }

    archive(event) {
        event.preventDefault()
        return AppContext.getApiClient().delete('/invoices/' + this.state.invoice.id, {}).then(q => {
            this.handleRefreshInvoice()
        })
    }

    forceCreateNextInvoice(event) {
        event.preventDefault()
        this.setState({
            moreLoading: true
        })
        return AppContext.getApiClient().post(`/recurring-invoices/${this.state.invoice.id}/invoices`, {}).then(q => {
            setTimeout(() => {
                this.setState({
                    moreLoading: false
                })
                this.handleRefreshInvoice()
            }, 2000)
        })
    }

    handleClosePreviewModal() {
        this.setState({
            modal: ''
        })
    }

    handlePaymentCloseAndRefresh() {
        setTimeout(() => {
            this.setState({
                paymentModal: '',
                firstRecurringInvoice: null,
                showFirstRecurringInvoice: false,
            })
            this.handleRefreshInvoice()
        }, 1000)
    }

    receivePayment(invoice, event) {
        event.preventDefault()
        this.setState({
            paymentModal: <ReceivePaymentModal
                onClose={this.handlePaymentCloseAndRefresh}
                invoice={invoice}
            />
        })
    }

    handlePageSizeChange(size) {
        this.setState({
            pageSize: size
        }, () => {
            this.refreshInvoices()
        })
    }


    refreshInvoices() {
        this.setState({
            loading: true,
        })

        let postData = {
            keywords: '*',
            objects: ['invoices'],
            fields: [
                'identifier',
            ],
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: 'sentAt',
            sortAsc: true,
            filters: {
                billingType: 'one-time',
                recurringInvoiceId: this.state.invoice.id,
            },
            lightResult: true,
        }
        AppContext.getApiClient().post('/listing/search', postData).then(res => {
            const r = res
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                totalItemsCount: r.metadata.totalItemsCount,
                loading: false,
            })
        })
    }

    headers() {
        return [
            <FormattedMessage
                id="invoice.listing.headers.id_label"
                defaultMessage="ID"
            />,
            <FormattedMessage
                id="invoice.listing.headers.amount_label"
                defaultMessage="Amount"
            />,
            this.state.invoice.attributes.recurringInfo.attributes.sendEmail ? <FormattedMessage
                id="invoice.analytics.recurring.next_send_date_label"
                defaultMessage="Send date"
            /> : <FormattedMessage
                id="invoice.analytics.recurring.next_creation_date_label"
                defaultMessage="Creation date"
            />,
            <FormattedMessage
                id="invoice.listing.headers.due_date_label"
                defaultMessage="Due date"
            />,
            <FormattedMessage
                id="invoice.listing.headers.status_label"
                defaultMessage="Status"
            />,
            '',
        ]
    }

    row(invoice) {
        const invoiceId = invoice.id
        invoice = invoice.attributes || invoice
        const inv = {
            attributes: invoice,
            id: invoiceId
        }

        return [
            <a href={'#'} onClick={this.loadAnotherInvoice(invoiceId)}>
                {invoice.identifier}
            </a>,
            <FormattedNumber
                style="currency"
                currency={invoice.currency || AppContext.getAccount().attributes.currency}
                value={invoice.totalAmount}
            />,
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(invoice.sentAt)} />,
            <InvoiceDueDate
                value={invoice.dueDate}
                status={invoice.status}
            />,
            <InvoiceStatusBadge
                status={invoice.status}
            />,
            !["draft", "fully-paid", "void"].includes(invoice.status) ?
                <ButtonWrapper
                    message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                        <FormattedMessage
                            id="listing.search.invoice_document_limit"
                            defaultMessage="Documents limit exceeded."
                        /> : ''}
                    onClick={(e) => this.receivePayment(inv, e)}
                    className={"btn btn-sm btn-success mr-2 mb-2"}
                    protectedClassName={"btn btn-sm btn-success mr-2 mb-2"}
                    premium={false}
                    protectionRule={!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) || invoice.importedAt === null}>
                    <span>
                        <Icon value={"dollar-sign"} className={"mr-1"} />
                        <FormattedMessage
                            id="invoice.analytics.receive_payment_btn"
                            defaultMessage="Receive payment"
                        />
                    </span>
                </ButtonWrapper>
                : '',
        ]
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: <ProposalPreviewModal
                onClose={this.handleClosePreviewModal}
                hash={this.state.proposal.attributes.hash}
                pdfLink={this.state.proposal.attributes.variables.document.pdfUri}
                proposalType={'invoice'}
            />
        })
    }

    openPricingTableModal(e) {
        e.preventDefault()
        this.setState({
            modal: <PricingTableModal
                quote={this.state.quote}
                invoice={this.state.invoice}
                onClose={this.handleClosePreviewModal}
            />
        })
    }

    renderCustomField(col) {
        return this.state.customFieldDefinitions
            .filter((_, index) => {
                const nbPerCol = Math.ceil(this.state.customFieldDefinitions.length / 2)
                if (col === 0) {
                    return index < nbPerCol
                } else {
                    return index >= nbPerCol
                }
            })
            .map(definition => {
                const value = this.getValueByDefinitionId(definition.id, definition.attributes.fieldType)
                if (!value) {
                    return <div />
                }
                return <div className={'w-100'} key={definition.id}>
                    <div className="w-100">
                        <label className="col-form-label custom-form-label">
                            <strong>
                                {definition.attributes.name}
                            </strong>
                        </label>
                    </div>
                    <p className="mb-0">
                        <span>{value}</span>
                    </p>
                </div>
            })
    }

    saveRecurringEmail(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) {
        AppContext.getApiClient()
            .patch('/invoices/' + this.state.invoice.id, {
                recurringInfo: {
                    emailSubject: subject,
                    emailAddresses: toEmail,
                    emailCCAddresses: ccEmail,
                    emailContent: content,
                    emailButtonLabel: buttonLabel,
                    emailFromName: fromName,
                }
            })
            .then(res => {
                const recInfo = res.attributes.recurringInfo.attributes
                this.setState({
                    emailSubject: recInfo.emailSubject,
                    toEmail: recInfo.emailAddresses,
                    ccEmail: recInfo.emailCCAddresses,
                    emailContent: recInfo.emailContent,
                    buttonLabel: recInfo.emailButtonLabel,
                    emailFromName: recInfo.emailFromName,
                })
            })
    }

    activate(event) {
        event.preventDefault()
        AppContext.getApiClient().patch('/invoices/' + this.state.invoice.id, {
            status: 'active'
        }).then(res => {
            this.handleRefreshInvoice()
        })
    }

    deactivate(event) {
        event.preventDefault()
        AppContext.getApiClient().patch('/invoices/' + this.state.invoice.id, {
            status: 'inactive'
        })
            .then(res => {
                this.handleRefreshInvoice()
            })
    }

    getCustomerEmailAddresses() {
        return GlobalHelper.formatContactEmail(this.state.invoice.attributes.contact.attributes.email, this.state.invoice.attributes.contact.attributes.name)
    }

    configureRecurringEmail(event) {
        event.preventDefault()
        const recurringInfo = this.state.invoice.attributes.recurringInfo && this.state.invoice.attributes.recurringInfo.attributes ? this.state.invoice.attributes.recurringInfo.attributes : {}
        const email = recurringInfo.emailAddresses ? recurringInfo.emailAddresses.split(',').map(a => a.toString().trim()) : this.getCustomerEmailAddresses()
        const ccEmail = recurringInfo.emailCCAddresses ? recurringInfo.emailCCAddresses.split(',').map(a => a.toString().trim()) : []
        const fromName = recurringInfo.emailFromName ? recurringInfo.emailFromName : this.state.proposal.attributes.variables.seller.name

        this.setState({
            modal: <SendEmailModal
                lastEmailSubject={this.state.emailSubject || recurringInfo.emailSubject}
                lastEmailContent={this.state.emailContent || recurringInfo.emailContent}
                lastEmailButtonLabel={this.state.buttonLabel || recurringInfo.emailButtonLabel}
                onSubmit={this.saveRecurringEmail}
                onClose={this.handleClosePreviewModal}
                toEmail={this.state.toEmail || email}
                ccEmail={this.state.ccEmail || ccEmail}
                pdfIncluded={this.state.pdfIncluded}
                proposalType={'invoice'}
                templateKey={'send-invoice'}
                isRecurringEmail={true}
                isCustomFromName={recurringInfo.emailFromName != ""}
                fromName={this.state.emailFromName ? this.state.emailFromName : fromName}
                ctaLabel={<FormattedMessage
                    id="common.send_email.modal.save_btn"
                    defaultMessage="Save"
                />}
            />
        })
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.handleRefreshInvoice()
    }

    render() {
        if (!this.state.invoice || !this.state.proposal) {
            return <div />
        }
        const contact = this.state.invoice.attributes.contact
        let contactPrimaryPhoneNumber = ''
        let contactPrimaryPhoneNumberExtension = ''
        for (let i = 0; i < contact.attributes.phoneNumbers.length; i++) {
            if (contact.attributes.phoneNumbers[i]["type"] == "primary") {
                contactPrimaryPhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                contactPrimaryPhoneNumberExtension = contact.attributes.phoneNumbers[i]["extension"]
            }
        }


        let list = <StandardList
            smallLine={true}
            className="row pt-2 d-none d-sm-none d-md-block"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        } else if (this.state.rows.length === 0) {
            list = <NoResult
                className={'py-2'}
                title={<FormattedMessage
                    id="invoice.analytics.recurring.no_invoice_created_title"
                    defaultMessage="No invoice created yet."
                />}
                message={<FormattedMessage
                    id="invoice.analytics.recurring.no_invoice_created_message"
                    defaultMessage="The first invoice will be created on {date}"
                    values={{
                        date: <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={new Date(this.state.invoice.attributes.recurringInfo.attributes.nextCreationDate)} />
                    }}
                />}
                noButton={true}
            />
        }

        const canActivate = ['inactive', 'finished'].includes(this.state.invoice.attributes.status) && this.state.invoice.attributes.recurringInfo.attributes.nextDueDate

        return <div className={'row analytics-page py-3 mb-5'}>
            {this.state.redirect}
            {this.state.modal}
            {this.state.paymentModal}
            <div className="col-12 ui-module">
                <div className={"row"}>
                    <div className={"col-12 col-md-6 border-right"}>
                        <h3 className={'m-0 d-flex align-items-center'}>
                            <FormattedMessage
                                id="invoice.analytics.title_label"
                                defaultMessage="Invoice {number}"
                                values={{
                                    number: this.state.invoice.attributes.identifier
                                }}
                            />
                            <h6 className="ml-2 d-inline mb-0">
                                <InvoiceStatusBadge status={this.state.invoice.attributes.status} />
                            </h6>
                        </h3>
                        <div className={'w-100'}>
                            {this.state.quoteReference ? <div className="form-group mb-0 pl-0">
                                <label className="pl-0 col-12 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="invoice.edit.invoice_details.quote_reference_label"
                                        defaultMessage="Quote invoiced"
                                    />
                                </label>
                                <div className="pl-0 col-12">
                                    <Link to={'/quotes/' + this.state.quoteReference.id + '/edit'}>
                                        {this.state.quoteReference.attributes.identifier}
                                    </Link>
                                </div>
                            </div> : ''}
                            <div className="form-group mb-0 pl-0">
                                <label className="pl-0 col-12 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="invoice.edit.invoice_details.interval_label"
                                        defaultMessage="Interval"
                                    />
                                </label>
                                <div className="pl-0 col-12">
                                    <RecurringInvoiceInterval
                                        editable={false}
                                        value={this.state.invoice.attributes.recurringInfo}
                                        invoiceId={this.state.invoice.id}
                                    />
                                </div>
                            </div>
                            <div className="form-group mb-0 pl-0">
                                <label className="pl-0 col-12 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="invoice.edit.invoice_details.schedule_label"
                                        defaultMessage="Schedule"
                                    />
                                </label>
                                <div className="pl-0 col-12">
                                    <RecurringInvoiceSchedule
                                        editable={false}
                                        value={this.state.invoice.attributes.recurringInfo}
                                        invoiceId={this.state.invoice.id}
                                    />
                                </div>
                            </div>
                            <div className="form-group mb-0 pl-0">
                                <label className="pl-0 col-12 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="invoice.edit.invoice_details.payment_term_label"
                                        defaultMessage="Payment terms"
                                    />
                                </label>
                                <div className="pl-0 col-12">
                                    <InvoicePaymentTerm
                                        value={this.state.invoice.attributes.paymentTerm ? this.state.invoice.attributes.paymentTerm.attributes.name : ''}
                                    />
                                </div>
                            </div>
                        </div>
                        {this.renderCustomField(0)}
                    </div>
                    <div className={"col-12 col-md-6 d-flex"}>
                        <div className={'flex-grow-1'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-0">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.contact_label"
                                            defaultMessage="Contact"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h4 className={'m-0'}>
                                <strong>
                                    <Link to={'/contacts/' + contact.id + '/details'}>
                                        {contact.attributes.name}
                                    </Link>
                                </strong>
                            </h4>
                            <p className={'m-0'}>
                                <a href={'mailto:' + contact.attributes.email}>
                                    {contact.attributes.email}
                                </a>
                            </p>
                            {contactPrimaryPhoneNumber ? <p className={'m-0'}>
                                <a href={'tel:' + contactPrimaryPhoneNumber + "," + contactPrimaryPhoneNumberExtension}>
                                    {GlobalHelper.formatPhoneNumber(contactPrimaryPhoneNumber, contact.attributes.address.countryCode) + contactPrimaryPhoneNumberExtension}
                                </a>
                            </p> : ''}
                            <div className="form-group mb-0 pl-0">
                                <label className="pl-0 col-12 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="invoice.edit.invoice_details.options_label"
                                        defaultMessage="Options"
                                    />
                                </label>
                                <div className="pl-0 col-12">
                                    <RecurringInvoiceOptions
                                        editable={false}
                                        value={this.state.invoice.attributes.recurringInfo}
                                        invoiceId={this.state.invoice.id}
                                        contactId={contact.id}
                                        contact={contact}
                                        refreshInvoice={this.refreshInvoices}
                                        locationId={this.state.invoice.attributes.locationId}
                                    />
                                </div>
                            </div>
                            {this.renderCustomField(1)}
                        </div>
                        <div className={'text-right'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.assign_to_label"
                                            defaultMessage="Assigned to"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <p className={'m-0'}>
                                <Icon value={'user'} /> <InlineEditUser
                                    editable={false}
                                    value={this.state.invoice.attributes.seller.attributes.name}
                                    userId={this.state.invoice.attributes.seller.id} />
                            </p>
                            {this.state.invoice.attributes.location ? <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.location_label"
                                            defaultMessage="Location"
                                        />
                                    </strong>
                                </label>
                            </div> : null}
                            {this.state.invoice.attributes.location ? <p className={'m-0'}>
                                <Icon value={'map-marker-alt'} /> {this.state.invoice.attributes.location.attributes.name}
                            </p> : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 px-0">
                <h4 className="p-0">
                    <Icon value={'sync'} className={'mr-2'} />
                    <FormattedMessage
                        id="invoice.analytics.recurring.upcoming_invoice"
                        defaultMessage="Upcoming invoice"
                    />
                </h4>
            </div>
            <div className="col-12 ui-module">
                {this.state.invoice.attributes.status === 'finished' ? <div className={'w-100 pb-2'}>
                    <Icon value={'info'} />
                    <FormattedMessage
                        id="invoice.analytics.recurring.no_more_invoice_finished"
                        defaultMessage="The recurring invoice is finished. No more invoice will be created."
                    />
                </div> : ''}
                {this.state.invoice.attributes.status === 'inactive' ? <div className={'w-100 pb-2'}>
                    <Icon value={'info'} />
                    <FormattedMessage
                        id="invoice.analytics.recurring.no_more_invoice_inactive"
                        defaultMessage="The recurring invoice is inactive. No invoice will be created."
                    />
                </div> : ''}
                <div className={'w-100 d-flex flex-wrap'}>
                    <div className={'mr-2 bg-custom-primary px-3'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label pt-2 text-white">
                                <strong>
                                    <FormattedMessage
                                        id="invoice.analytics.total_amount_label"
                                        defaultMessage="Total"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h2 className={'m-0'}>
                            <FormattedNumber
                                value={this.state.invoice.attributes.totalAmount}
                                style={'currency'}
                                currency={this.state.invoice.attributes.currency}
                            />
                        </h2>
                    </div>
                    {this.state.invoice.attributes.recurringInfo.attributes.nextCreationDate && this.state.invoice.attributes.recurringInfo.attributes.createDaysInAdvance > 0 ? <div className={'mr-2 bg-secondary px-3'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label py-2 text-white">
                                <strong>
                                    {this.state.invoice.attributes.recurringInfo.attributes.sendEmail ? <FormattedMessage
                                        id="invoice.analytics.recurring.next_send_date_label"
                                        defaultMessage="Send date"
                                    /> : <FormattedMessage
                                        id="invoice.analytics.recurring.next_creation_date_label"
                                        defaultMessage="Creation date"
                                    />}
                                </strong>
                            </label>
                        </div>
                        <h5 className={'m-0 text-white border-0'}>
                            <FormattedDate
                                year='numeric'
                                month='long'
                                day='numeric'
                                value={new Date(this.state.invoice.attributes.recurringInfo.attributes.nextCreationDate)} />
                        </h5>
                    </div> : ''}
                    {this.state.invoice.attributes.recurringInfo.attributes.nextDueDate ? <div className={'mr-2 bg-secondary px-3'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label py-2 text-white">
                                <strong>
                                    <FormattedMessage
                                        id="invoice.analytics.recurring.next_invoice_date_label"
                                        defaultMessage="Invoice date"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h5 className={'m-0 text-white border-0'}>
                            <FormattedDate
                                year='numeric'
                                month='long'
                                day='numeric'
                                value={new Date(this.state.invoice.attributes.recurringInfo.attributes.nextDueDate)} />
                        </h5>
                    </div> : ''}
                    <div className={'mr-2'}>
                        <div className={'mb-2 w-100'}>
                            <a target={'_blank'} href={'#'} className={'btn btn-sm btn-outline-primary'} onClick={this.openPricingTableModal}>
                                <Icon value={'dollar-sign'} />
                                <FormattedMessage
                                    id="quote.analytics.pricing_table_btn"
                                    defaultMessage="Show details"
                                />
                            </a>
                        </div>
                        <div className={" w-100"}>
                            <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={this.openPreview} >
                                <Icon value={"eye"} className={"mr-1"} />
                                <FormattedMessage
                                    id="invoice.analytics.preview_btn"
                                    defaultMessage="Preview"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 px-0">
                <h4 className="p-0 m-0">
                    <Icon value={'invoice'} className={'mr-2'} />
                    <FormattedMessage
                        id="invoice.analytics.recurring.created_invoices"
                        defaultMessage="Invoices"
                    />
                </h4>
            </div>
            <div className="col-12 px-0 ">
                {list}
                <Pagination
                    showPageSize={true}
                    onPageSizeChange={this.handlePageSizeChange}
                    activePage={this.state.activePage}
                    pageSize={this.state.pageSize}
                    totalItemsCount={this.state.totalItemsCount}
                    onChange={this.handlePageChange}
                />
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {this.state.isEditable ? <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                <div className={"d-flex"}>
                                    <div className={""}>
                                        <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={this.openPreview} >
                                            <Icon value={"eye"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="invoice.analytics.preview_btn"
                                                defaultMessage="Preview"
                                            />
                                        </button>
                                    </div>
                                    <div className="mr-2 mb-2 ">
                                        <button className="btn btn-sm btn-outline-primary" type="button" id="dropdownMoreButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {!this.state.moreLoading ? <Icon value={"ellipsis-h"} className={"mr-1"} /> : <LoadingSpinner
                                                height={15}
                                                width={3}
                                                className="px-2"
                                            />}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">
                                            <a className="dropdown-item" href="#" onClick={this.handleOnEdit}>
                                                <Icon value={"pen"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.edit_btn"
                                                    defaultMessage="Edit"
                                                />
                                            </a>
                                            <ConfirmButton
                                                isLink={true}
                                                onModalRender={(m, c) => { this.setState({ modal: m }, c) }}
                                                onClick={this.forceCreateNextInvoice}
                                                message={<span>
                                                    <FormattedMessage
                                                        id="invoice.analytics.create_next_invoice_message"
                                                        defaultMessage="Are you sure you want to create the next invoice now ?"
                                                    />
                                                </span>}
                                                className="dropdown-item"
                                            >
                                                <Icon value={"plus-circle"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.analytics.create_next_invoice_btn"
                                                    defaultMessage="Create next invoice"
                                                />
                                            </ConfirmButton>
                                            <ConfirmButton
                                                isLink={true}
                                                onModalRender={(m, c) => { this.setState({ modal: m }, c) }}
                                                onClick={this.archive}
                                                identifier={this.state.invoice.attributes.identifier}
                                                message={<span>
                                                    <FormattedMessage
                                                        id="invoice.analytics.delete_message"
                                                        defaultMessage="Are you sure you want to delete invoice {identifier} ?"
                                                        values={{
                                                            identifier: this.state.invoice.attributes.identifier
                                                        }}
                                                    />
                                                </span>}
                                                className="dropdown-item text-danger"
                                            >
                                                <Icon value={"trash"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.analytics.delete_btn"
                                                    defaultMessage="Delete"
                                                />
                                            </ConfirmButton>
                                        </div>
                                    </div>
                                </div>
                                <div className={""}>
                                    {this.state.invoice.attributes.status !== 'finished' && this.state.invoice.attributes.recurringInfo.attributes.sendEmail ? <button
                                        className="btn btn-primary mr-2 mb-2" onClick={this.configureRecurringEmail}>
                                        <Icon value={"envelope"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="invoice.analytics.configure_email_btn"
                                            defaultMessage="Configure email"
                                        />
                                    </button> : ''}
                                    {canActivate ? <ActionButton className="btn btn-success mr-2 mb-2" onClick={this.activate}>
                                        <Icon value={"toggle-on"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="invoice.analytics.activate_btn"
                                            defaultMessage="Activate"
                                        />
                                    </ActionButton> : ''}
                                    {['active'].includes(this.state.invoice.attributes.status) ? <ActionButton className="btn btn-warning mr-2 mb-2" onClick={this.deactivate}>
                                        <Icon value={"toggle-off"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="invoice.analytics.deactivate_btn"
                                            defaultMessage="Deactivate"
                                        />
                                    </ActionButton> : ''}
                                </div>
                            </div> : <div className="col-12">
                                <p className="text-align-right text-warning m-0">
                                    <FormattedMessage
                                        id="invoice.analytics.archived_invoice_info"
                                        defaultMessage="This invoice is archived and can't be found in search results."
                                    />
                                </p>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default InvoiceRecurring





// WEBPACK FOOTER //
// ./src/invoice/recurring.component.jsx